const ESSIO_LANGUAGE_ROUTE_MAP: Record<string, string> = {
  de: 'de',
  en: 'en',
  es: 'es',
  ja: 'ja',
  ko: 'ko',
  kor: 'ko',
  pt: 'pt',
  th: 'th',
  zh: '',
  'zh-hans': '',
  'zh-cn': '',
  'zh-hant': '',
  'zh-tw': '',
  'zh-hk': '',
};

/**
 * 将 RoboNeo 当前语言映射为 Essio 落地页路由前缀，中文沿用默认路径。
 */
export function getEssioLanguageRoutePrefix(languageCode?: string) {
  const normalizedLanguageCode = (languageCode || '').trim().toLowerCase();
  if (!normalizedLanguageCode) return '';

  return ESSIO_LANGUAGE_ROUTE_MAP[normalizedLanguageCode]
    ?? ESSIO_LANGUAGE_ROUTE_MAP[normalizedLanguageCode.split('-')[0]]
    ?? '';
}

/**
 * 根据当前语言生成 Essio 平台工具页路由，默认中文不拼接 /zh。
 */
export function getLocalizedAiToolRoute(route: string, languageCode?: string) {
  const essioLanguageRoutePrefix = getEssioLanguageRoutePrefix(languageCode);
  if (!essioLanguageRoutePrefix) return route;

  return route.replace('/--roboneo/', `/--roboneo/${essioLanguageRoutePrefix}/`);
}
